module.exports = __webpack_public_path__ + "img/cf03972807277f07c22e8df4ddb1b3be.892a908c.webp";